import AcfHelper from "../../_acf";
import Slider from "../../utils/_slider";
import Breakpoints from "../../utils/_breakpoints";

const blockClass = 'solution-custom-block';
const slidersClass = 'solution-custom-slider';

const SolutionCustom = {};

SolutionCustom.blockName = "solutions-custom";

SolutionCustom.init = () => {
    AcfHelper.handleInit(SolutionCustom.blockName, () => {
        Slider.init({
            slider: slidersClass,
            container: blockClass,
        }, {
            slidesPerView: 1.1,
            loop: false,
            breakpoints: {
                [Breakpoints.getValues().md]: {
                    slidesPerView: 2,
                },
                [Breakpoints.getValues().lg]: {
                    slidesPerView: 3.2,
                }
            }
        });
    });
};

SolutionCustom.init();
export default SolutionCustom;
